import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.50131 0C0.673266 0 0 0.672397 0 1.50184V19.4982C0 20.331 0.672158 21 1.50131 21H3.15762L4.35 24L7.50288 21H22.4987C23.3267 21 24 20.3276 24 19.4982V1.50184C24 0.669036 23.3278 0 22.4987 0H1.50131Z",
      fill: "#0C8A65"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "8.10001",
      cy: "6.30005",
      r: "1.5",
      fill: "white"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "15.9",
      cy: "6.30005",
      r: "1.5",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M6.63617 13.3947C6.71955 13.4898 6.86628 13.6425 7.07138 13.8338C7.40737 14.1472 7.79109 14.4597 8.21826 14.7519C9.45917 15.6007 10.814 16.1155 12.2459 16.1155C14.0922 16.1155 15.871 15.2464 17.4953 13.3947C17.7684 13.0833 17.7374 12.6095 17.426 12.3363C17.1146 12.0632 16.6408 12.0942 16.3676 12.4056C13.945 15.1675 11.4827 15.1675 9.06512 13.5138C8.70387 13.2667 8.378 13.0013 8.09451 12.7369C7.99638 12.6454 7.91107 12.5611 7.83939 12.4865C7.79886 12.4443 7.77341 12.4165 7.76382 12.4056C7.49067 12.0942 7.01681 12.0632 6.70542 12.3363C6.39403 12.6095 6.36302 13.0833 6.63617 13.3947Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }